import * as React from 'react'

export interface IAudio {
  autoplay?: boolean
  controls?: boolean
  loop?: boolean
  muted?: boolean
  src: string
  oncanplay?: () => void
  onpause?: () => void
  onplay?: () => void
  onplaying?: () => void
}

const Audio = ({
  src = '',
  autoplay = true,
  controls = false,
  loop = false,
  muted = false,
  oncanplay,
  onpause,
  onplay,
  onplaying,
}: IAudio) => {
  return (
    <audio
      src={src}
      autoPlay={autoplay}
      controls={controls}
      loop={loop}
      muted={muted}
    >
      oncanplay={oncanplay}
      onpause={onpause}
      onplay={onplay}
      onplaying={onplaying}> 您的浏览器不支持 audio 标签。
    </audio>
  )
}

export default Audio
